module.exports = __webpack_public_path__ + "static/media/poll-zoom.9a38c856.svg";